export default {
  invoices: [],
  proFormaInvoices: [],
  cnDns: [],
  payables: [],
  document: null,
  summary: {},
  collection: [],
  eInvoiceCount:[],
  transactionReport:[],
}
